'use client'
import { useState, useRef } from 'react'
import { HttpService, ServiceEndpoints, Messages, SimpleReactValidator } from '@/config/NextImport'
import { showSuccess } from '@/components/CustomSwal'

const StayConnected = () => {
  const btnNewsletterRef = useRef<any>(null)

  const Validator = useRef(new SimpleReactValidator())
  const defaultInputs = {
    email: '',
    name: '',
    gender: ''
  }
  const [Inputs, setInputs] = useState(defaultInputs)
  const [isForceUpdate, setForceUpdate] = useState(false)

  const handleNewslatterForm = (e: any) => {
    if (e.target.name === 'gender') {
      if (e.target.checked) {
        setInputs({ ...Inputs, [e.target.name]: e.target.value })
      } else {
        setInputs({ ...Inputs, [e.target.name]: '' })
      }
    } else {
      setInputs({ ...Inputs, [e.target.name]: e.target.value })
    }
    setForceUpdate(!isForceUpdate)
  }
  const submitNewsletterEmail = async (e: any) => {
    e.preventDefault()
    if (!Validator.current.allValid()) {
      Validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    } else {
      Validator.current.hideMessages()
      setForceUpdate(!isForceUpdate)
    }

    const param = {
      email: Inputs.email,
      name: Inputs.name,
      gender: Inputs.gender
    }
    if (btnNewsletterRef.current) btnNewsletterRef.current.setAttribute('disabled', 'disabled')
    const response = await HttpService.postApi(ServiceEndpoints.postNewsletterEmail, param, false)
    if (btnNewsletterRef.current) btnNewsletterRef.current.removeAttribute('disabled')
    // const Swal = (await import('sweetalert2')).default
    if (response.result[0][0].result === 2) {
      showSuccess(Messages.NewsletterAlready_title, Messages.NewsletterAlready)
      // Swal.fire({
      //   title: Messages.NewsletterAlready_title,
      //   text: Messages.NewsletterAlready
      // })
    } else {
      showSuccess(Messages.NewsletterThankyou, Messages.NewsletterSubmitted)
      // Swal.fire({
      //   title: Messages.NewsletterThankyou,
      //   text: Messages.NewsletterSubmitted
      // })
    }
    setInputs(defaultInputs)
  }
  return (
    <>
      <section className="subscribe-section">
        <div className="container">
          <div className="row justify-content-center mx-0">
            <div className="col-md-12 col-lg-12">
              <div className="subscribe-box-content text-center">
                {/* <h2>Subscribe to our Newsletter</h2> */}
                <div className="newsletter-sub-title">
                  Subscribe to our newsletter now and join our sparkling community!
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12">
              <div className="subscribe-box-form">
                <form
                  className="row"
                  onSubmit={submitNewsletterEmail}
                >
                  <div className="form-group col-md-6 col-xl-3">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      onChange={handleNewslatterForm}
                      value={Inputs.name}
                      placeholder="Name"
                    />
                    {Validator.current.message('Name', Inputs.name, 'required|max:255', {
                      className: 'error'
                    })}
                  </div>
                  <div className="form-group col-md-6 col-xl-3">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email_address"
                      placeholder="Email Address"
                      onChange={handleNewslatterForm}
                      value={Inputs.email}
                    />
                    {Validator.current.message(
                      'Email Address',
                      Inputs.email,
                      'required|email|max:255',
                      { className: 'error' }
                    )}
                  </div>
                  <div className="col-md-6 col-xl-3 mb-2">
                    <div className="d-flex align-items-center">
                      <div className="form-check">
                        <input
                          className="form-check-input ms-0"
                          type="radio"
                          name="gender"
                          id="male"
                          value="male"
                          checked={Inputs.gender === 'male'}
                          onChange={handleNewslatterForm}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="male"
                        >
                          Male
                        </label>
                      </div>

                      <div className="form-check mx-3">
                        <input
                          className="form-check-input ms-0"
                          type="radio"
                          name="gender"
                          id="female"
                          value="female"
                          checked={Inputs.gender === 'female'}
                          onChange={handleNewslatterForm}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="female"
                        >
                          Female
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input ms-0"
                          type="radio"
                          name="gender"
                          id="other"
                          value="other"
                          checked={Inputs.gender === 'other'}
                          onChange={handleNewslatterForm}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="other"
                        >
                          Other
                        </label>
                      </div>
                    </div>
                    {Validator.current.message('Gender', Inputs.gender, 'required', {
                      className: 'error'
                    })}
                  </div>
                  <div className="col-md-6 col-xl-3 mb-2">
                    <button
                      type="submit"
                      className="form-control btn btn-black custom-hover newsletter-box-btn"
                      name="subscribe"
                      ref={btnNewsletterRef}
                    >
                      Subscribe
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <GoogleReviewsSwiper /> */} 
    </>
  )
}

export default StayConnected
